module.exports = "/static/assets/19b1c1d2f4b6173cc8d4c718c0611248.png";